import {
  modeInterpretariat,
  renderUserName,
  roles,
  typeIntervention,
} from "../../../utils/constants";
import { AiFillCalendar } from "react-icons/ai";
import { PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { HiOutlineMail } from "react-icons/hi";
import React from "react";
import dayjs from "../../../utils/dayjs";
import { onlyRoleMapping, userHasLevel } from "../../../engine/AuthRoute";
import { Link } from "react-router-dom";
import routes from "../../../engine/routes";
import { Button } from "antd";
import { renderAdress } from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { DurationHourChecker } from "../PrestationDetail/DurationHourChecker";
import {
  disabledDateNext12Months,
  disabledDatePast,
  validateTimeBetween,
} from "../../../shared/components/CustomForm/form.helpers";

export const prestationInputs = (prestation, user) => {
  const {
    intervention: { startDate, endDate, location, extra },
    interventionFinal,
    institution,
    intervenant,
    intervenantFinal,
    intervention,
    applicationAt,
    responsable,
    beneficiary,
    noSharedCost,
  } = prestation;

  const disabledDate = current => {
    if (onlyRoleMapping([roles.institution, roles.interprete])) {
      return disabledDatePast(current) || disabledDateNext12Months(current);
    } else {
      return false;
    }
  };

  return [
    {
      parentLabel: "",
      children: [
        {
          disabledDate,
          required: true,
          label: "Date et heure de début réel",
          rules: [
            refValidator => ({
              validator(_) {
                return validateTimeBetween(
                  refValidator,
                  "interventionFinal.startDate",
                  "interventionFinal.endDate",
                  user,
                  false,
                  false,
                );
              },
            }),
          ],
          name: "interventionFinal.startDate",
          value:
            interventionFinal.startDate === null
              ? dayjs(startDate)
              : dayjs(interventionFinal.startDate),
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          type: "date-time",
          col: 12,
        },
        {
          disabledDate,
          required: true,
          label: "Date et heure de fin réel",
          name: "interventionFinal.endDate",
          rules: [
            refValidator => ({
              validator(_) {
                return validateTimeBetween(
                  refValidator,
                  "interventionFinal.startDate",
                  "interventionFinal.endDate",
                  user,
                  false,
                  false,
                );
              },
            }),
          ],
          value:
            interventionFinal.endDate === null
              ? dayjs(endDate)
              : dayjs(interventionFinal.endDate),
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          type: "date-time",
          col: 12,
        },
        {
          col: 24,
          type: "component",
          name: "durationHour",
          noWrapper: true,
          component: ({ refForm }) => (
            <DurationHourChecker
              keys={[
                "interventionFinal.startDate",
                "interventionFinal.endDate",
              ]}
            />
          ),
        },
        {
          visible: userHasLevel({
            only: {
              [roles.permanance]: "r", //
              [roles.admin]: "r", //
              [roles.institution]: "r", //
            },
          }),
          label: "Date de dépôt de la demande",
          name: "applicationAt",
          required: true,
          // quote: "",
          value: applicationAt === null ? null : dayjs(applicationAt),
          // suffixIcon: <AiFillCalendar />,
          showTime: true,
          type: "date-time",
          col: 12,
        },
        intervention.type === typeIntervention.in_person
          ? {
              required: true,
              label: "Adresse d'intervention réelle",
              name: "interventionFinal.location",
              value: interventionFinal?.location
                ? interventionFinal.location
                : prestation.intervention.location,
              type: "google-adress",
              col: 24,
            }
          : {},
        // {
        //   label: null,
        //   name: "noSharedCost",
        //   type: "checkbox-bool",
        //   checkboxs: [
        //     {
        //       value: true,
        //       // label: "Expert",
        //       label:
        //         "Cette prestation ne partage pas ses frais de déplacements",
        //       // description: "Formation avancée AVIC avec 5 années au moins d'expérience",
        //     },
        //   ],
        //   col: 24,
        // },
        {
          label: "Cette prestation ne partage pas ses frais de déplacements",
          description: "",
          name: "noSharedCost",
          visible: userHasLevel({
            only: {
              [roles.admin]: "r", //
              [roles.permanance]: "r", //
            },
          }),
          type: "checkbox-bool",
          value: noSharedCost,
          col: 24,
        },
        intervention.type === typeIntervention.in_person
          ? {
              visible: userHasLevel({
                only: {
                  [roles.admin]: "r", //
                },
              }),
              label: "Lieu de départ réel de l'interprète",
              name: "interventionFinal.locationFrom",
              value: interventionFinal?.locationFrom
                ? interventionFinal.locationFrom
                : prestation.intervention.locationFrom || "",
              type: "google-adress",
              col: 24,
            }
          : {},
        {
          label: "Adresse de facturation",
          name: "billing",
          visible: userHasLevel({
            only: {
              [roles.permanance]: "r", //
              [roles.admin]: "r", //
            },
          }),
          addonBefore: <UserOutlined />,
          quote: (
            <>
              <p>Vous pouvez les éditer sur la page de l'institution </p>
              <a
                target={"_blank"}
                href={
                  routes.institutions(prestation?.institution?._id).addresses
                    .path
                }
              >
                Editer les addresses
              </a>
            </>
          ),
          quoteIcon: "info",
          type: "dynamic-select",
          required: true,
          value: prestation.billing === null ? null : prestation.billing._id,
          multiple: false,
          endPoint: `addresses?institution=${prestation?.institution?._id}&type=postal&availableForBilling=true`,
          itemsCallBack: addresses => {},
          inputSize: "large",
          noSorting: true,
          itemCallback: adress => {
            return {
              key: adress._id,
              label: renderAdress(
                adress,
                prestation?.institution?.defaultAddress === adress._id,
                prestation?.institution,
              ),
              value: adress._id,
            };
          },
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Référence du bénéficiaire (facturation)",
      description:
        "Les informations affichées ci-dessous apparaîtront dans la facture.",
      children: [
        {
          label: "Référence du bénéficiaire ",
          name: "beneficiary.reference",
          type: "input",
          col: 24,
        },
        {
          label: "Nom du bénéficiaire",
          name: "beneficiary.firstname",
          type: "input",
          capitalize: true,
          visible:
            beneficiary.firstname.length > 0 || beneficiary.lastname.length > 0,
          col: 24,
        },
        {
          label: "Prénom du bénéficiaire",
          name: "beneficiary.lastname",
          type: "input",
          capitalize: true,
          visible:
            beneficiary.firstname.length > 0 || beneficiary.lastname.length > 0,
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Personnel responsable de l’entretien",
      children: [
        {
          placeholder: "Nom",
          value: responsable?.lastname,
          name: "responsable.lastname",
          type: "input",
          capitalize: true,
          required: true,
          addonBefore: <UserOutlined />,
          col: 12,
        },
        {
          placeholder: "Prénom",
          value: responsable?.firstname,
          name: "responsable.firstname",
          required: true,
          capitalize: true,
          addonBefore: <UserOutlined />,
          type: "input",
          col: 12,
        },
        {
          placeholder: "E-mail",
          value: responsable?.email,
          name: "responsable.email",
          addonBefore: <HiOutlineMail />,
          type: "input",
          col: 12,
        },
        {
          placeholder: "Téléphone",
          value: responsable?.phone,
          name: "responsable.phone",
          addonBefore: <PhoneOutlined />,
          type: "input",
          col: 12,
        },
        {
          label: "Remarque",
          name: "interventionFinal.note",
          addonBefore: <HiOutlineMail />,
          placeholder: "Remarque",
          type: "textarea",
          col: 24,
        },
      ],
    },
  ];
};
